import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import Header from "./Header";
const Layout = ({ children, activeTab = 0 }) => {
    return (_jsxs(Box, Object.assign({ sx: { display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" } }, { children: [_jsx(Header, { activeTab: activeTab }), _jsx(Box, Object.assign({ component: "main", sx: {
                    flex: 1,
                    p: 2,
                    backgroundColor: (theme) => theme.palette.background.default,
                    overflow: "auto",
                    minHeight: 0,
                } }, { children: children }))] })));
};
export default Layout;
